import {Stack, Typography} from "@mui/material";
import {Navigate, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import LogsTable from "../common/LogsTable";
import {useCanViewLogs} from "crqlar-react-common/dist/utils/hooks/logs/useCanViewLogs";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import SettingsListPage from "../layout/SettingsListPage";

const LogsList = () => {

    useTrackScreenVisit("system logs");

    const {t} = useTranslation();
    const navigate = useNavigate();

    const {canViewLogs, isLoading: accessLoading} = useCanViewLogs();

    // Hide the page entirely from users who aren't allowed to see logs.
    if (!accessLoading && !canViewLogs) {
        return <Navigate to={"/system/"} replace/>;
    }

    return (
        <SettingsListPage title={t('Logs')} back={() => navigate('/system')}>
            <Stack sx={{width: "100%", height: "100%", minHeight: 0, gap: 2}}>
                <Typography variant={"body2"} color={"text.secondary"} textAlign={"start"}>
                    {t("Audit trail of changes made across your organization.")}
                </Typography>

                {canViewLogs && <LogsTable/>}
            </Stack>
        </SettingsListPage>
    );
};

export default LogsList;
